import React, { lazy, Suspense } from "react";

const InteractiveMap = lazy(() => import("./InteractiveMap"));

const mapContainerStyle = {
  alignItems: "center",
  background: "#f2f4f5",
  boxSizing: "border-box",
  display: "flex",
  height: "250px",
  justifyContent: "center",
  margin: "auto",
  padding: "10px",
  position: "relative",
  width: "350px",
};

const Map = ({
  startLocationLatitude,
  startLocationLongitude,
  endLocationLatitude,
  endLocationLongitude,
}) => {
  return (
    <Suspense
      fallback={
        <div style={mapContainerStyle} role="status">
          Loading route map…
        </div>
      }
    >
      <InteractiveMap
        startLocationLatitude={startLocationLatitude}
        startLocationLongitude={startLocationLongitude}
        endLocationLatitude={endLocationLatitude}
        endLocationLongitude={endLocationLongitude}
      />
    </Suspense>
  );
};

export default Map;
